import { useTranslation } from 'react-i18next';

interface WelcomeScreenProps {
  onLogin: () => void;
}

export default function WelcomeScreen({ onLogin }: WelcomeScreenProps) {
  const { t } = useTranslation();
  return (
    <main className="relative font-sans bg-[#161616] text-white flex flex-col min-h-full">
      {/* Stadium backdrop — anchored to the bottom so the pitch sits under the CTA */}
      <div
        aria-hidden
        className="pointer-events-none absolute inset-0 bg-cover bg-bottom bg-no-repeat"
        style={{ backgroundImage: 'url(/field.png)' }}
      />
      <div className="relative z-10 w-full max-w-[393px] mx-auto flex-1 flex flex-col items-center px-6 pt-6 pb-8">
        {/* Packs + logo: anchored to the top */}
        <div className="flex flex-col items-center">
          <div className="relative w-[124.23px] h-[134.67px] origin-top [@media(max-height:640px)]:scale-75 [@media(max-height:640px)]:mb-[-32px]">
            <img
              src="/pack.png"
              alt=""
              className="absolute left-[-13.46px] top-[-6.86px] w-[114.19px] max-w-none -rotate-[16.34deg]"
            />
            <img
              src="/pack.png"
              alt=""
              className="absolute left-[23.6px] top-[-13.04px] w-[114.19px] max-w-none rotate-[12.1deg]"
            />
          </div>

          <img
            src="/welcome-logo.png"
            alt={t('welcome.logoAlt')}
            className="mt-3 [@media(max-height:640px)]:mt-2 w-[215px] h-[107px] [@media(max-height:640px)]:w-[172px] [@media(max-height:640px)]:h-[86px] object-contain"
          />
        </div>

        <p className="mt-[100px] w-[243px] h-[45px] text-center font-poppins text-[12px] font-semibold leading-[15px] text-[#F7FBFD]">
          {t('welcome.tagline')}
        </p>

        <button
          type="button"
          onClick={onLogin}
          className="mt-auto self-center w-[361px] h-12 rounded-full bg-white font-sans text-[16px] font-bold text-[#1f1f1f] transition-all duration-150 active:scale-[0.98] flex items-center justify-center gap-3"
        >
          {t('welcome.cta')}
        </button>
      </div>
    </main>
  );
}
